/* BRV SNNRS theme — drawers, quick add, upsell, cart updates */
(function () {
  const qs = (s, r = document) => r.querySelector(s);

  function openDrawer(drawer, backdrop) {
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.hidden = false;
  }
  function closeDrawer(drawer, backdrop) {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
  }

  async function refreshCart(open) {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    const html = await res.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextDrawer = parsed.querySelector('[data-cart-drawer]');
    const current = qs('[data-cart-drawer]');
    if (nextDrawer && current) current.innerHTML = nextDrawer.innerHTML;

    const cart = await (await fetch('/cart.js')).json();
    const count = qs('[data-cart-count]');
    if (count) count.textContent = cart.item_count;
    if (open) openDrawer(qs('[data-cart-drawer]'), qs('[data-cart-backdrop]'));
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    if (!res.ok) return;
    await refreshCart(true);
  }

  async function changeLine(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    });
    await refreshCart(true);
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;

    if (target.hasAttribute('data-menu-open')) openDrawer(qs('[data-menu-drawer]'), qs('[data-menu-backdrop]'));
    if (target.hasAttribute('data-menu-close')) closeDrawer(qs('[data-menu-drawer]'), qs('[data-menu-backdrop]'));
    if (target.hasAttribute('data-cart-open')) { event.preventDefault(); openDrawer(qs('[data-cart-drawer]'), qs('[data-cart-backdrop]')); }
    if (target.hasAttribute('data-cart-close')) closeDrawer(qs('[data-cart-drawer]'), qs('[data-cart-backdrop]'));

    const qty = target.closest('[data-qty]');
    if (qty) { event.preventDefault(); changeLine(qty.dataset.line, qty.dataset.qty); }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-menu-backdrop]')) closeDrawer(qs('[data-menu-drawer]'), qs('[data-menu-backdrop]'));
    if (event.target.closest('[data-cart-backdrop]')) closeDrawer(qs('[data-cart-drawer]'), qs('[data-cart-backdrop]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDrawer(qs('[data-menu-drawer]'), qs('[data-menu-backdrop]'));
    closeDrawer(qs('[data-cart-drawer]'), qs('[data-cart-backdrop]'));
  });

  // Private video entrance
  const privateEntry = qs('[data-private-entry]');
  if (privateEntry) {
    const panel = qs('[data-access-panel]', privateEntry);
    const creatorPanel = qs('[data-creator-panel]', privateEntry);
    const backdrop = qs('[data-access-backdrop]', privateEntry);
    const video = qs('video', privateEntry);

    const openAccess = () => {
      if (!panel || !backdrop) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      document.body.classList.add('private-access-open');
    };
    const closeAccess = () => {
      if (!panel || !backdrop) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.body.classList.remove('private-access-open');
    };
    const openCreator = () => {
      if (!creatorPanel || !backdrop) return;
      creatorPanel.classList.add('is-open');
      creatorPanel.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      document.body.classList.add('private-access-open');
    };
    const closeCreator = () => {
      if (!creatorPanel || !backdrop) return;
      creatorPanel.classList.remove('is-open');
      creatorPanel.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.body.classList.remove('private-access-open');
    };

    qs('[data-access-open]', privateEntry)?.addEventListener('click', openAccess);
    qs('[data-access-close]', privateEntry)?.addEventListener('click', closeAccess);
    qs('[data-creator-open]', privateEntry)?.addEventListener('click', openCreator);
    qs('[data-creator-close]', privateEntry)?.addEventListener('click', closeCreator);
    backdrop?.addEventListener('click', () => { closeAccess(); closeCreator(); });

    qs('[data-private-sound]', privateEntry)?.addEventListener('click', (event) => {
      if (!video) return;
      video.muted = !video.muted;
      event.currentTarget.setAttribute('aria-label', video.muted ? 'Turn film sound on' : 'Mute film');
      qs('[data-sound-off]', privateEntry).hidden = !video.muted;
      qs('[data-sound-on]', privateEntry).hidden = video.muted;
      video.play();
    });

    qs('[data-access-form]', privateEntry)?.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = event.currentTarget.querySelector('input[type="email"]');
      const email = input?.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input?.focus();
        return;
      }
      try {
        window.localStorage.setItem('brv-access-email', email);
      } catch (error) {}
      document.documentElement.classList.add('access-granted');
      document.body.classList.remove('private-access-open');
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-quick-add], [data-upsell-form], #product-form')) {
      event.preventDefault();
      addToCart(new FormData(form));
    }
  });

  // Media switching (thumbnails + variant images)
  const setActiveMedia = (predicate) => {
    const items = Array.from(document.querySelectorAll('[data-media-index]'));
    const target = items.find(predicate);
    if (!target) return;
    const index = target.dataset.mediaIndex;
    items.forEach((media) => media.classList.toggle('is-active', media.dataset.mediaIndex === index));
    document.querySelectorAll('[data-media-target]').forEach((item) => {
      const active = item.dataset.mediaTarget === index;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    const scroller = target.parentElement;
    if (scroller && scroller.scrollWidth > scroller.clientWidth) {
      scroller.scrollTo({ left: target.offsetLeft - scroller.offsetLeft, behavior: 'smooth' });
    }
  };

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-media-target]');
    if (!thumbnail) return;
    setActiveMedia((media) => media.dataset.mediaIndex === thumbnail.dataset.mediaTarget);
  });

  // Product page variant selection
  const variantData = qs('[data-variant-data]');
  if (variantData) {
    const variants = JSON.parse(variantData.textContent);
    const input = qs('[data-variant-input]');
    const button = qs('[data-add-button]');
    const price = qs('[data-product-price]');
    const stock = qs('[data-product-stock]');
    const sku = qs('[data-product-sku]');
    const moneyFormat = document.documentElement.dataset.moneyFormat || '${{amount}}';
    const formatMoney = (cents) => moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2)).replace('{{amount_no_decimals}}', Math.round(cents / 100));

    const syncChips = () => {
      document.querySelectorAll('.size-options .chip').forEach((chip) => {
        chip.classList.toggle('is-active', !!chip.querySelector('input')?.checked);
      });
      document.querySelectorAll('.size-options fieldset, fieldset.size-options').forEach((fieldset) => {
        const checked = fieldset.querySelector('[data-option-selector]:checked');
        const label = fieldset.querySelector('[data-option-value]');
        if (checked && label) label.textContent = `${checked.value.toUpperCase()} SELECTED`;
      });
    };

    const currentOptions = () =>
      Array.from(document.querySelectorAll('[data-option-selector]:checked')).map((el) => el.value);

    const applyVariant = (variant) => {
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = 'UNAVAILABLE';
        }
        if (stock) stock.innerHTML = 'THIS COMBINATION IS UNAVAILABLE';
        return;
      }
      if (input) input.value = variant.id;
      const formattedPrice = formatMoney(variant.price);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? `${button.dataset.addLabel || 'ADD TO BAG'} — ${formattedPrice}`
          : 'SOLD OUT';
      }
      if (price) price.textContent = formattedPrice;
      if (stock) stock.innerHTML = variant.available ? '<span></span> IN STOCK — READY TO SHIP' : 'CURRENTLY UNAVAILABLE';
      if (sku && variant.sku) sku.textContent = variant.sku.toUpperCase();

      const mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) setActiveMedia((media) => media.dataset.mediaId === String(mediaId));

      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-option-selector]')) return;
      syncChips();
      const chosen = currentOptions();
      applyVariant(variants.find((variant) => variant.options.every((option, index) => option === chosen[index])));
    });

    syncChips();
    const initial = variants.find((variant) => String(variant.id) === (input && input.value));
    if (initial && initial.featured_media) {
      setActiveMedia((media) => media.dataset.mediaId === String(initial.featured_media.id));
    }
  }
})();

